"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Pressable = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Pressable"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../utils");
var _ThemeProvider = require("../ThemeProvider");
var _ItemContent = _interopRequireDefault(require("./ItemContent"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.a11yProps, _utils.linkProps, _utils.viewProps]);
function selectItemStyles(_ref) {
  let {
    backgroundColor,
    borderColor,
    borderWidth,
    borderStyle,
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom,
    justifyContent,
    verticalAlign
  } = _ref;
  return {
    backgroundColor,
    borderTopColor: borderColor,
    borderTopWidth: borderWidth,
    borderTopStyle: borderStyle,
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom,
    justifyContent,
    ...(0, _ThemeProvider.verticalAlignRow)(verticalAlign)
  };
}

/**
 `SideNav.Item` is a navigational element that is used within `SideNav` or `SideNav.ItemsGroup`.

 This component can only be accessed as a name-spaced component: `SideNav.Item`.
 */
const Item = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    children,
    itemId,
    groupId,
    onPress,
    isActive = false,
    isExpanded = false,
    tokens,
    variant,
    href,
    accessibilityRole = 'link',
    testID,
    ...props
  } = _ref2;
  const handlePress = () => onPress(itemId, groupId);
  const {
    hrefAttrs,
    rest
  } = _utils.hrefAttrsProp.bundle(props);
  const selectedProps = selectProps({
    accessibilityRole,
    href,
    onPress: handlePress,
    hrefAttrs,
    ...rest
  });
  const getTokens = (0, _ThemeProvider.useThemeTokensCallback)('SideNavItem', tokens, variant);
  const getAppearanceState = _ref3 => {
    let {
      hovered,
      focused
    } = _ref3;
    return {
      hover: hovered,
      active: isActive,
      expanded: isExpanded,
      focus: focused
    };
  };
  const getPressableStyle = pressableState => ({
    ...selectItemStyles(getTokens(getAppearanceState(pressableState))),
    ...(_Platform.default.OS === 'web' ? {
      outline: 'none'
    } : {})
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Pressable.default, {
    ref: ref,
    style: getPressableStyle,
    accessibilityState: {
      selected: isActive
    },
    ...selectedProps,
    children: pressableState => {
      const themeTokens = getTokens(getAppearanceState(pressableState));
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ItemContent.default, {
        tokens: themeTokens,
        children: children
      });
    }
  });
});
Item.displayName = 'Item';
Item.propTypes = {
  ...selectedSystemPropTypes,
  /**
   * Text content of the `Item`.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * @ignore
   * Set internally in `SideNav` render function - used to keep track of active item.
   */
  itemId: _propTypes.default.string,
  /**
   * @ignore
   * Set internally in `SideNav` render function - used to keep track of expanded items groups.
   */
  groupId: _propTypes.default.string,
  onPress: _propTypes.default.func,
  href: _propTypes.default.string,
  /**
   * On Web if href is passed, React Native Web maps this object's props to
   * `rel`, `target` and `download` attrs.
   */
  hrefAttrs: _propTypes.default.shape(_utils.hrefAttrsProp.types),
  /**
   * @ignore
   * Set internally in `SideNav` render function.
   */
  isActive: _propTypes.default.bool,
  /**
   * @ignore
   * Set internally in `SideNav.ItemsGroup` render function. Used to mark expanded `ItemsGroup` parent.
   */
  isExpanded: _propTypes.default.bool,
  accessibilityRole: _propTypes.default.string,
  testID: _propTypes.default.number,
  tokens: (0, _utils.getTokensPropType)('SideNavItem'),
  variant: _utils.variantProp.propType
};
var _default = exports.default = Item;